<template>
  <div>
    <v-container class="pl-10 pr-10 ml-0">
      <MembershipManage></MembershipManage>
    </v-container>
    <PageLoadingProgress ref="PageLoadingProgress"></PageLoadingProgress>
  </div>
</template>

<script>
const MembershipManage = () =>
  import(
    /* webpackChunkName: "ViewMembershipManage" */ "@/components/membership/membership_manage/MembershipManage.vue"
  );

import PageLoadingProgress from "@/components/common/PageLoadingProgress.vue";

export default {
  components: {
    MembershipManage,
    PageLoadingProgress,
  },
  methods: {
    progressShow: function() {
      this.$refs.PageLoadingProgress.show();
    },
    progressHide: function() {
      this.$refs.PageLoadingProgress.hide();
    },
  },
  mounted: function() {
    this.progressShow();
  },
};
</script>
